'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var notistack = require('notistack');
var constants_properties = require('../constants/properties.js');

var useSnackbar = function () {
    var enqueueSnackbarOriginal = notistack.useSnackbar().enqueueSnackbar;
    // i had to cast this since typescript was complaining about the original params
    // and updating them to fit the notistack props broke our code
    var enqueueSnackbar = enqueueSnackbarOriginal;
    var showSuccessSnackbar = React.useCallback(function (_a) {
        var text = _a.text, actionText = _a.actionText, onActionClick = _a.onActionClick, persist = _a.persist;
        return enqueueSnackbar({
            variant: constants_properties.SnackbarVariant.SUCCESS,
            text: text,
            actionText: actionText,
            onActionClick: onActionClick,
            persist: persist,
        }, {
            autoHideDuration: actionText && onActionClick ? 9000 : 4000,
            key: text,
            persist: persist,
        });
    }, [enqueueSnackbar]);
    var showErrorSnackbar = React.useCallback(function (_a) {
        var text = _a.text, actionText = _a.actionText, onActionClick = _a.onActionClick, persist = _a.persist;
        return enqueueSnackbar({
            variant: constants_properties.SnackbarVariant.ERROR,
            text: text,
            actionText: actionText,
            onActionClick: onActionClick,
        }, {
            autoHideDuration: actionText && onActionClick ? 9000 : 4000,
            key: text,
            persist: persist,
        });
    }, [enqueueSnackbar]);
    var showWarningSnackbar = React.useCallback(function (_a) {
        var text = _a.text, actionText = _a.actionText, onActionClick = _a.onActionClick, persist = _a.persist;
        return enqueueSnackbar({
            variant: constants_properties.SnackbarVariant.WARNING,
            text: text,
            actionText: actionText,
            onActionClick: onActionClick,
        }, {
            autoHideDuration: actionText && onActionClick ? 9000 : 4000,
            key: text,
            persist: persist,
        });
    }, [enqueueSnackbar]);
    var showDownloadSnackbar = React.useCallback(function (_a) {
        var text = _a.text, actionText = _a.actionText, onActionClick = _a.onActionClick, persist = _a.persist;
        return enqueueSnackbar({
            variant: constants_properties.SnackbarVariant.DOWNLOAD,
            text: text,
            actionText: actionText,
            onActionClick: onActionClick,
        }, {
            autoHideDuration: actionText && onActionClick ? 9000 : 4000,
            key: text,
            persist: persist,
        });
    }, [enqueueSnackbar]);
    var showPlainSnackbar = React.useCallback(function (_a) {
        var text = _a.text, actionText = _a.actionText, onActionClick = _a.onActionClick, persist = _a.persist;
        return enqueueSnackbar({
            variant: constants_properties.SnackbarVariant.PLAIN,
            text: text,
            actionText: actionText,
            onActionClick: onActionClick,
        }, {
            autoHideDuration: actionText && onActionClick ? 9000 : 4000,
            key: text,
            persist: persist,
        });
    }, [enqueueSnackbar]);
    return {
        showSuccessSnackbar: showSuccessSnackbar,
        showErrorSnackbar: showErrorSnackbar,
        showWarningSnackbar: showWarningSnackbar,
        showDownloadSnackbar: showDownloadSnackbar,
        showPlainSnackbar: showPlainSnackbar,
    };
};

exports["default"] = useSnackbar;
